import React, { ChangeEvent, useState } from "react";
import { Card, CardContent, makeStyles, CardHeader, TextField, Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { setLogin } from "../actions";


const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  card: {
    width: '400px',
    height: '200px',
    position: 'relative',
    // display: 'flex',
  },
  cardContent: {
    flexGrow: 1,
    // display: 'flex',
  },
  text: {
    // flexGrow: 1,
  },
  buttons: {
    textAlign: 'right',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    boxSizing: 'border-box',
  }
});

export default function Login(props: { onOk: () => void }) {
  const classes = useStyles();
  const [secret, setSecret] = useState(localStorage.getItem('secret'));
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSecret(e.target.value);
  }
  const { onOk } = props;
  const dispatch = useDispatch();
  const handleSubmit = () => {
    localStorage.setItem('secret', secret || '');
    dispatch(setLogin(false));
    onOk();
  }

  return (
    <div className={classes.root}>
      <Card className={classes.card} raised>
        <CardHeader title="Login"></CardHeader>
        <CardContent className={classes.cardContent}>
          <div className={classes.text}>
            <TextField fullWidth label="Secret" required value={secret} error={!!secret} onChange={handleChange} />
          </div>
        </CardContent>
        <CardContent className={classes.buttons}>
          <Button onClick={handleSubmit} disabled={!secret}>Ok</Button>
        </CardContent>
      </Card>
    </div>
  )
}